import {
  MicError,
  MicErrorTypeLifecycle,
  MicErrorTypeMediaStream,
  MicErrorTypeStt,
  MicErrorTypeSttQueue
} from "../../models/microphone";

// MediaStream related errors
// https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#Exceptions
export const MIC_ERR_MEDIA_STREAM: {
  [key in MicErrorTypeMediaStream]: MicError;
} = {
  ABORT: {
    key: "mic-err_media-stream_abort",
    value: "AbortError"
  },
  NOT_ALLOWED: {
    key: "mic-err_media-stream_not-allowed",
    value: "NotAllowedError"
  },
  NOT_FOUND: {
    key: "mic-err_media-stream_not-found",
    value: "NotFoundError"
  },
  NOT_READABLE: {
    key: "mic-err_media-stream_not-readable",
    value: "NotReadableError"
  },
  OVERCONSTRAINT: {
    key: "mic-err_media-stream_overconstrained",
    value: "OverconstrainedError"
  },
  SECURITY: {
    key: "mic-err_media-stream_security",
    value: "SecurityError"
  },
  TYPE: {
    key: "mic-err_media-stream_type",
    value: "TypeError"
  }
};

export const MIC_ERR_LIFECYCLE: {
  [key in MicErrorTypeLifecycle]: MicError;
} = {
  AUDIO_CONTEXT_NOT_AVAILABLE: {
    key: "mic-err_lifecycle_audio-context-not-available",
    description:
      "AudioContext nor webkitAudioContext is available in the current browser context"
  }
};

// STT errors are common to all proxy services
export const MIC_ERR_STT: {
  [key in MicErrorTypeStt]: MicError;
} = {
  END_OF_STREAM: {
    key: "mic-err_stt-proxy_end-of-stream"
  },
  SOFT_TIMEOUT: {
    key: "mic-err_stt-proxy_soft-timeout",
    description:
      "API decided that time is up! No more recognition and what transcribed so far is expected to be returned"
  },
  FAILED_TRANSCRIPTION: {
    key: "mic-err_stt-proxy_failed-to-transcribe",
    description: "Azure could not have transcribed the submitted audio"
  }
};

// Errors specific to SttQueue implementation
export const MIC_ERR_STT_QUEUE: {
  [key in MicErrorTypeSttQueue]: MicError;
} = {
  NO_DATA: {
    key: "mic-err_stt-queue_no-data",
    description: "Microphone is started but no data is actually recorded"
  },
  API_CALL: {
    key: "mic-err_stt-queue_api-call",
    description: "An API call has failed"
  },
  NO_QUEUE_ID_RECEIVED: {
    key: "mic-err_stt-queue_no-queue-id-received",
    description: "API did not provide a queue-id"
  }
};
